import {Component, OnInit, ViewChild} from '@angular/core';
import { Router } from '@angular/router';
import {GeocodingService} from "../../../utils/leaflet/service/geocoding.service";
import {TechnicalDataService} from "../technical-data.service";
import {MapService} from "../../../utils/leaflet/service/map.service";
import {DataManagementService} from "../../data-management/data-management.service";
import {ToastrService} from "ngx-toastr";
import {SigninService} from "../../../signin/signin.service";
import {ChartFullscreenService} from "../../../utils/chart-fullscreen/chart-fullscreen.service";
import {
  DeviceCarb,
  DeviceOpt,
  DeviceTemp,
  ExportTempVariation,
  RepFuelVariation,
  TechnicalData
} from "../../../model/technical-data";
import {Subscription} from "rxjs";
import {Group, Vehicule} from "../../../model/data-managemnt";
import {ModalDirective} from "ngx-bootstrap/modal";
import * as Highcharts from 'highcharts/highstock';
import HighchartsMore from 'highcharts/highcharts-more';
HighchartsMore(Highcharts);
import HichartsExportingData from 'highcharts/modules/export-data';
HichartsExportingData(Highcharts);
import {formatDate} from "@angular/common";

@Component({
  selector: 'app-temp-data',
  templateUrl: './temp-data.component.html',
  styleUrls: ['./temp-data.component.scss'],
})
export class TempDataComponent  implements OnInit {

  formNotShown = false;
  fullscreenChartId: string | null = null;

  selected: any = {
    startDate: new Date(new Date().setHours(0, 0, 0, 0)+ (60 * 60 * 1000)).toISOString(),
    endDate: new Date(new Date().setHours(23, 59, 59, 999)+ (60 * 60 * 1000)).toISOString(),
  };

//Chart vars
  chart: any;
  options: any;
  serieName: any;

  //Device Options
  deviceopt: DeviceOpt;
  //Device Carburant
  devicecarb: DeviceCarb;
  deviceTemp: DeviceTemp;
  AllGroups: Subscription;
  vehicule: Vehicule;
  technicaldata: TechnicalData[];
  technicaldataReport15min: TechnicalData[];
  repFuelVariation: RepFuelVariation[] = [];
  variationList: ExportTempVariation[] = new Array();

  // startDate: Date = new Date();
  // endDate: Date = new Date();

  isResultLoaded: boolean = true;
  volume: number;
  useTemp: boolean = false;
  map: any;
  dropdownList = [];
  isGroupLoaded = false;
  @ViewChild('mapModal') public mapModal: ModalDirective;


  constructor(private geocodingService: GeocodingService, private technicalDataService: TechnicalDataService, private mapService: MapService,
              public dataManagementService: DataManagementService, public toastr: ToastrService, public signinService: SigninService,
              private router: Router, private chartFullscreenService: ChartFullscreenService) {
  }

  ionViewWillEnter() {
    this.dataManagementService.ensureSelectedVehicle();
  }

  ionViewWillLeave() {
    this.exitChartFullscreen();
  }

  isChartFullscreen(chartId: string): boolean {
    return this.fullscreenChartId === chartId;
  }

  async toggleChartFullscreen(chartId: string, chart: any): Promise<void> {
    const exiting = this.fullscreenChartId === chartId;
    if (exiting) {
      this.fullscreenChartId = null;
      await this.chartFullscreenService.exitLandscape();
    } else {
      if (this.fullscreenChartId) {
        this.fullscreenChartId = null;
        await this.chartFullscreenService.exitLandscape();
      }
      this.fullscreenChartId = chartId;
      await this.chartFullscreenService.enterLandscape();
    }
    this.chartFullscreenService.scheduleReflow(chart);
  }

  private async exitChartFullscreen(): Promise<void> {
    if (!this.fullscreenChartId) {
      return;
    }
    this.fullscreenChartId = null;
    await this.chartFullscreenService.exitLandscape();
    this.chartFullscreenService.scheduleReflow(this.options);
  }

  dateHandle(event: any, type: string) {
    if (type === 'start') {
      this.selected.startDate = event.detail.value;
    } else {
      this.selected.endDate = event.detail.value;
    }
  }

  close() {
    this.router.navigate(['/client']);
  }

  ngOnInit() {
    this.dataManagementService.GroupsLoaded$.subscribe(groups => this.onGroupLoaded(groups));
    this.dataManagementService.init();
  }


  onGroupLoaded(groups: Group[]) {
    if (this.dataManagementService.groups) {
      this.isGroupLoaded = true;
    }
  }


  ngOnDestroy() {
    if (this.AllGroups) this.AllGroups.unsubscribe();
  }

  //check if the series is empty or not
  ChartSeries(data: any = []) {
    let ok: boolean;
    data.forEach(dt => {
      ok = dt.y == undefined ? false : true;
    });
    return ok;
  }

  //Return the position of Yaxis
  PositionYaxis(data: any, option: string): number {
    for (let i = 0; i < data.length; i++) {
      if (data[i].title.text === option) {
        return i;
      }
    }
    return -1;
  }

  displayChart() {
    this.isResultLoaded = false;
    this.dropdownList = [];
    this.useTemp = false;
    this.isResultLoaded = false;
    this.technicalDataService.getDeviceTemp(this.dataManagementService.selectedVehicule.device.idDevice).subscribe(resp => {
      this.deviceTemp = resp;
      this.dropdownList.push({
        id: 0,
        option: "temp",
        itemName: "Temperature"
      });
      this.dropdownList.push({
        id: 1,
        option: "di1",
        itemName: "Etat de porte"
      });
      this.dropdownList.push({
        id: 2,
        option: "accum_odo",
        itemName: "Odomètre"
      });
      this.dropdownList.push({
        id: 3,
        option: "di2",
        itemName: "Etat de porte 2"
      });
      this.isResultLoaded = true;
    })

    // Options vars
    let temp = [];
    let ranges = [];
    let door = [];
    let accum_odo = [];
    let door2 = [];

    this.variationList = [];

    this.technicaldataReport15min = [];
    //Get Fuel Data and fill all options
    this.technicalDataService.getFuelDetail(this.dataManagementService.selectedVehicule.device.idDevice, {
      startDate: this.selected.startDate,
      endDate: this.selected.endDate
    }, "temp ,di1, accum_odo, di2, ignition").subscribe(res => {
      this.technicaldata = res;
      if (this.technicaldata.length == 0) {
        this.toastr.warning("Pas de données à afficher");
      }

      let lastInvalid = false;
      let lastTemp = -1000;

      let maxTemp: number = -1000;
      let minTemp: number = 1000;

      let cursor = this.selected.startDate;
      let ign = false;
      this.technicaldataReport15min = [];
      this.technicaldata.forEach(stat => {
          //for (let i;i<this.technicaldata.length;i++){
          //    let stat=this.technicaldata[i];
          if (this.dataManagementService.selectedVehicule.device.opt.useTemp == 1) {
            this.useTemp = true;
            if (stat.date > cursor || ign != stat.ignition) {
              // console.log("date cursor => " + new Date(stat.date) + " WTF " + new Date(cursor));
              while (stat.date > cursor)
                cursor = cursor + 1000 * 60 * 15;
              ign = stat.ignition;
              this.dataManagementService.getGeocodingPosition(stat, "TechnicalData", this.dataManagementService.selectedVehicule.device.idDevice);


              if (stat.temp != undefined && Math.floor(stat.temp / 256) != 128 && stat.temp != 65535) {
                this.technicaldataReport15min.push(stat);


                for (let i = 0; i < this.technicaldataReport15min.length; i++) {
                  let variation: ExportTempVariation = new ExportTempVariation;
                  variation.date = this.technicaldataReport15min[i].date;
                  variation.lat = this.technicaldataReport15min[i].latitude;
                  variation.lng = this.technicaldataReport15min[i].longitude;
                  if (this.technicaldataReport15min[i].ignition == true) {
                    variation.status = 'drive';
                  } else {
                    variation.status = 'stop';
                  }

                  variation.temp = Math.round((this.technicaldataReport15min[i].temp * 10) / 16 / 10);


                  this.variationList.push(variation);
                }
              }

            }
          }


          let valid = false;
          if (stat.temp > 10000 && stat.temp < 10600) {//Bug Hardware conversion temp négative BLE
            let rawTemp = stat.temp * 100 / 16;
            stat.temp = ((rawTemp - 65536) / 100) * 16;
          }
          if (stat.temp != undefined && Math.floor(stat.temp / 256) != 128 && stat.temp != 65535) {
            if (stat.temp > 32768)
              stat.temp = stat.temp - 65536;
            if (stat.temp / 16 < 125 && stat.temp / 16 > -50) {
              //if(lastTemp==-1000||Math.abs(lastTemp-Math.floor(stat.temp * 10) / 16 /10)<10)
              valid = true;
            }
          }
          if (valid && !lastInvalid) {
            let currtemp = Math.floor(stat.temp * 10) / 16 / 10;
            if (currtemp > maxTemp)
              maxTemp = currtemp;
            if (currtemp < minTemp)
              minTemp = currtemp;

            temp.push({
              x: stat.date, y: currtemp
            });
            if (this.deviceTemp.isThresholdHighEnable && this.deviceTemp.isThresholdLowEnable) {
              ranges.push([stat.date, this.deviceTemp.thresholdHighValue, this.deviceTemp.thresholdLowValue])
            }
            lastTemp = Math.floor(stat.temp * 10) / 16 / 10;

          }
          lastInvalid = !valid;
          if (stat.di1 != undefined) {
            door.push({ x: stat.date, y: (stat.di1 == 1 ? 0 : 1) });
          }
          if (stat.accum_odo != undefined) {
            accum_odo.push({ x: stat.date, y: stat.accum_odo });
          }
          if (stat.di2 != undefined) {
            door2.push({ x: stat.date, y: (stat.di2 == 1 ? 0 : 1) });
          }

        }
      )

      let yaxis = [];
      let serie = [];
      let doorDet = false;
      let doorDet2 = false;
      for (let i = 1; i < door.length; i++) {

        if (
          door[i].y > door[i - 1].y ||
          door[i].y < door[i - 1].y
        ) {
          doorDet = true;
          door[i].x = door[i - 1].x;
        }
      }

      for (let j = 1; j < door2.length; j++) {

        if (
          door2[j].y > door2[j - 1].y ||
          door2[j].y < door2[j - 1].y
        ) {
          doorDet2 = true;
          door2[j].x = door2[j - 1].x;
        }
      }

      if (this.ChartSeries(temp) == true) {
        yaxis.push({
          title: {
            text: "temperature",
          },
          labels: {
            format: "{value} " + "°C",
            style: {
              color: "rgb(107, 57, 156)"
            }
          }
        });
        serie.push({
          name: "Temperature(Max:" + (maxTemp != -1000 ? maxTemp : "--") + " °C / Min : " + (minTemp != 1000 ? minTemp : "--") + "°C)",
          data: temp,
          zIndex: 1,
          yAxis: this.PositionYaxis(yaxis, "temperature"),
        });
      }

      if (this.ChartSeries(door) == true && doorDet) {
        yaxis.push({
          title: {
            text: "porte",
            style: {
              color: "rgb(255, 127, 0)"
            }
          },
          labels: {
            style: {
              color: "rgb(255, 127, 0)"
            }
          },
          min: 0,
          alignTicks: false,
          endOnTick: false,
          tickInterval: 1
        });
        serie.push({
          name: "Etat de porte",
          data: door,
          type: "area",
          color: "rgb(255, 127, 0)",
          yAxis: this.PositionYaxis(yaxis, "porte"),
        });

      }

      if (this.ChartSeries(accum_odo)) {
        yaxis.push({
          title: {
            text: "odomètre",
            style: {
              color: "rgb(44, 161, 33)"
            }
          },
          labels: {
            format: "{value} " + "Km",
            style: {
              color: "rgb(44, 161, 33)"

            }
          },
          min: null
        });

        serie.push({
          name: 'odomètre',
          data: accum_odo,
          color: 'rgb(44, 161, 33)',
          tooltip: {
            valueSuffix: "KM",
            valueDecimals: 2
          },
          yAxis: this.PositionYaxis(yaxis, "odomètre"),
        });
      }

      if (this.dataManagementService.selectedVehicule.device.opt.useDoor == 2) {
        if (this.ChartSeries(door2) == true && doorDet2) {
          yaxis.push({
            title: {
              text: "porte 2",
              style: {
                color: "rgb(240, 225, 96)"
              }
            },
            labels: {
              style: {
                color: "rgb(240, 225, 96)"
              }
            },
            min: 0,
            alignTicks: false,
            endOnTick: false,
            tickInterval: 1
          });
          serie.push({
            name: "Etat de porte 2",
            data: door2,
            type: "area",
            color: "rgb(240, 225, 96)",
            yAxis: this.PositionYaxis(yaxis, "porte"),
          });

        }
      }

      //Create a new HighChart
      this.options = new Highcharts.Chart({
        title: { text: "Véhicule: " + this.dataManagementService.selectedVehicule.matricule },
        chart: {
          renderTo: 'container',
          height: 400,
          // zoomType: 'x'
        },

        yAxis: yaxis,

        series: serie,
        xAxis: [{
          type: 'datetime',
          tickInterval: 3600 * 1000,
          labels: {
            formatter: function () {
              return formatDate(
                this.value,
                'dd/MM/yyyy, HH:MM',
                'en-US'
              );
            }
          },
          crosshair: true
        }],
        plotOptions: {
          series: {
            turboThreshold: 100000,
            events: {
              click: (event) => {
                console.log('clicked!!');
                this.getPathDatails(this.dataManagementService.selectedVehicule.device.idDevice, event.point.x, event.point.x)
              },
            },
          }
        },
      });
      this.isResultLoaded = true;
    });

  }

  saveInstance(chartInstance) {
    this.chart = chartInstance;
  }

  onSeriesMouseOver(e) {
    this.serieName = e.context.name;
  }

  chooseGroup(group) {
    this.dataManagementService.selectedGroup = group;;
    if (this.dataManagementService.selectedGroup.vehicules.length > 0 && this.dataManagementService.selectedGroup) {
      this.dataManagementService.selectedVehicule = this.dataManagementService.selectedGroup.vehicules[0];
    }
  }

  chooseVehicule(vehicule) {
    this.dataManagementService.selectedVehicule = vehicule;
  }

  public showChildModal(): void {
    this.mapModal.show();
  }

  public hideChildModal(): void {
    this.mapModal.hide();
  }


  getPathDatails(idDevice: number, dateD: any, dateF: any) {
    let options = [];
    var data: any;
    this.technicalDataService.getFuelDetail(idDevice, {
      startDate: dateD,
      endDate: dateF
    }, options).subscribe(resp => {
      console.log(resp)
      data = resp[0];

    })
  }

  onMapReady(map) {
    setTimeout(() => {
      map.invalidateSize(true)
    }, 300)
  }

  getColor(ign): string {
    if (ign)
      return "rgba(0,200,20,0.2)";
    return "rgba(200,0,20,0.2)";
  }




}
